import { TaxonomyMasterPage } from "@/components/taxonomy-master-page";

export default function Stacks() {
  return <TaxonomyMasterPage kind="stack" title="Stacks" />;
}
